import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction, fetchApi } from "@inmagik/react-crud"
import type { Theme } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useThemes(params: Record<string, string> = {}) {
  return useList<Theme>(`${API_URL}/admin/themes`, {
    query: params,
  })
}

export function useTheme(id: number | undefined) {
  return useDetail<Theme>(`${API_URL}/admin/themes`, id?.toString())
}

export function useCreateTheme() {
  return useCreate<Theme>(`${API_URL}/admin/themes`, {
    encode: "formdata",
  })
}

export function useUpdateTheme() {
  return useUpdate<Theme>(`${API_URL}/admin/themes`, {
    encode: "formdata",
  })
}

export function useDeleteTheme() {
  return useDelete(`${API_URL}/admin/themes`)
}

export function usePartialUpdateTheme() {
  return usePartialUpdate<Theme>(`${API_URL}/admin/themes`, {
    encode: "formdata",
  })
}

export function useDeleteMultiTheme() {
  return useAction(`${API_URL}/admin/themes/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}

export function useThemeLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/themes/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Theme>
  }, [])
}

export function useThemesLazy(params: Record<string, string | number | Array<number>> = {}) {
  const auth = useAuth()
  return useCallback((paramsOverride: Record<string, string | number | Array<number>> = {}) => {
    const combinedParams = { ...params, ...paramsOverride }
    const qs = normalizeParams(combinedParams).toString()
    return fetchApi(`${API_URL}/admin/themes?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Theme[] }>
  }, [])
}


